<template>
  <div data-qa="appointment_form_confirmation">
    <UserAuthorization
      v-if="!useAuthMt"
      ref="user-authorization"
      persistent
      is-render-in-modal
      :is-phone-readonly="Boolean(useAuthMt ? userPhoneV2 : userPhone)"
      :is-visible="!isPhoneConfirmed"
      :init-phone="useAuthMt ? userPhoneV2 : userPhone"
      :hook-before-submit-form="checkCodeRequestAvailability"
      is-country-authorization
      @authorization:requested="handleRequestConfirm"
      @authorization:confirmed="handlePhoneConfirmed"
      @authorization:just-confirmed="handlePhoneJustConfirmed"
    />
    <template v-if="isPhoneConfirmed || useAuthMt">
      <div
        v-if="isVisibleWarningInfoTelemed"
        class="mb-6"
      >
        <AppointmentWarningInfoTelemed
          data-qa="apointment_warning_info_telemed"
        />
      </div>
      <v-expand-transition v-if="isTelemedMedical">
        <div v-if="isUnderagePatient">
          <BaseAlert
            color="text-error"
            class="mb-4"
            text="Онлайн-приём несовершеннолетних пока не поддерживается"
          />
        </div>
      </v-expand-transition>
      <PaymentInfo />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { APPOINTMENT_YANDEX_GOALS, TELEMED_YANDEX_GOALS } from 'www/yandexGoals'
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'
import UserAuthorization from 'www/vue_components/common/UserAuthorization/UserAuthorization.vue'
import { PAYMENT_TYPES, USER_ACTION_AFTER_AUTH } from 'www/vue_components/common/AppointmentPage/constants'
import AppointmentWarningInfoTelemed from 'www/vue_components/common/AppointmentPage/components/common/AppointmentWarningInfoTelemed.vue'
import {
  useLpuDataStore,
  useUserDataStore,
  useClubDataStore,
  useDoctorDataStore,
  useYandexGoalsStore,
  useAuthorizationStore, // todo(useAuthMt) - удалить
  useAppointmentDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'
import PaymentInfo from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/PaymentInfo.vue'

export default {
  name: 'AppointmentFormConfirmation',
  components: {
    BaseAlert,
    PaymentInfo,
    UserAuthorization, // todo(useAuthMt) - удалить
    AppointmentWarningInfoTelemed,
  },
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
  computed: {
    ...mapState(useUserDataStore, [
      'isErrorWarningInfo',
      'isVisibleWarningInfoTelemed',
    ]),
    ...mapState(useUserDataStore, { // todo(useAuthMt) - изменить на массив и переименовать поле
      userPhoneV2: 'userPhone',
    }),
    ...mapState(useAuthorizationStore, [ // todo(useAuthMt) - удалить
      'userPhone', // todo(useAuthMt) - удалить
      'isPhoneConfirmed', // todo(useAuthMt) - удалить
      'userActionAfterAuthorization', // todo(useAuthMt) - удалить
    ]),
    ...mapState(useClubDataStore, [
      'userClubData',
    ]),
    ...mapState(useClubDataStore, [
      'isClubAvailable',
      'isClubSelectTypePaymentVisible',
      'selectedPaymentType',
    ]),
    ...mapState(useLpuDataStore, [
      'lpuData',
    ]),
    ...mapState(useAppointmentDataStore, [
      'appointmentPlaceTypes',
      'isAppointmentPaymentInfoVisible',
      'useAuthMt',
    ]),
    ...mapState(useDoctorDataStore, [
      'selectedWorkplace',
    ]),
    ...mapState(useLpuDataStore, [
      'isTelemedMedical',
    ]),
    ...mapState(useFamilyProfilesStore, [
      'isUnderagePatient',
    ]),
    hasAppointmentRestrictions() {
      return Boolean(this.selectedWorkplace.appointmentRestrictions?.length)
    },
  },
  watch: {
    selectedWorkplace() {
      if (this.isPhoneConfirmed || this.useAuthMt) {
        this.requestOfferData()
      }
    },
  },
  created() {
    const { isClub, isLpu } = this.appointmentPlaceTypes

    if (!isClub && !isLpu) {
      return
    }

    if (this.selectedPaymentType === PAYMENT_TYPES.club || isClub) {
      this.setStateSelectedPaymentType(PAYMENT_TYPES.club)
    } else {
      this.setStateSelectedPaymentType(PAYMENT_TYPES.lpu)
    }
  },
  mounted() {
    if (this.useAuthMt) {
      this.requestOfferData()

      if (this.lpuData.isEnabledClubDiscount) {
        this.requestUserClubData()
      }
    } else {
      this.updateUserAuthorizationRef(this.$refs['user-authorization'])
    }
  },
  methods: {
    handlePhoneConfirmed(phoneConverted) {
      if (this.useAuthMt) {
        return
      }

      this.updateIsPhoneConfirmed(true)
      this.updateUserPhone(phoneConverted)
      this.requestOfferData()
    },
    handlePhoneJustConfirmed(confirmationMethod) {
      if (this.useAuthMt) {
        return
      }

      if (this.appointmentPlaceTypes.isTelemed) {
        this.sendYaGoal({
          name: TELEMED_YANDEX_GOALS.appointmentPhoneConfirmed,
          formType: 'telemed',
          objectType: 'doctor',
        })
      } else {
        this.sendYaGoal({
          name: APPOINTMENT_YANDEX_GOALS.phoneConfirmed,
          formType: 'any',
          objectType: 'any',
        })
      }

      if (confirmationMethod.isCall) {
        this.sendYaGoal({
          name: APPOINTMENT_YANDEX_GOALS.confirmedByCall,
          formType: 'any',
          objectType: 'any',
        })
      }

      if (confirmationMethod.isSms) {
        this.sendYaGoal({
          name: APPOINTMENT_YANDEX_GOALS.confirmedBySms,
          formType: 'any',
          objectType: 'any',
        })
      }

      if (this.lpuData.isEnabledClubDiscount) {
        this.requestUserClubData()
      }

      this.handleUserActionAfterAuth()
    },
    handleUserActionAfterAuth() {
      if (this.useAuthMt) {
        return
      }

      const isNeededSendForm = this.userActionAfterAuthorization === USER_ACTION_AFTER_AUTH.sendAppointmentForm

      this.updateUserActionAfterAuthorization(null)

      if (isNeededSendForm) {
        this.confirmAppointment()
      }
    },
    handleRequestConfirm() {
      if (this.useAuthMt) {
        return
      }

      this.sendYaGoal({
        name: APPOINTMENT_YANDEX_GOALS.showCodeInput,
        formType: 'any',
        objectType: 'any',
      })
    },
    checkCodeRequestAvailability() {
      this.sendYaGoal({
        name: APPOINTMENT_YANDEX_GOALS.clickConfirmPhone,
        formType: 'any',
        objectType: 'any',
      })

      return true
    },
    ...mapActions(useAuthorizationStore, [ // todo(useAuthMt) - удалить
      'updateUserPhone', // todo(useAuthMt) - удалить
      'updateIsPhoneConfirmed', // todo(useAuthMt) - удалить
      'updateUserAuthorizationRef', // todo(useAuthMt) - удалить
      'updateUserActionAfterAuthorization', // todo(useAuthMt) - удалить
    ]),
    ...mapActions(useClubDataStore, [
      'requestOfferData',
      'requestUserClubData',
      'setStateSelectedPaymentType',
    ]),
    ...mapActions(useYandexGoalsStore, [
      'sendYaGoal',
    ]),
    ...mapActions(useAppointmentDataStore, [
      'confirmAppointment',
    ]),
  },
}
</script>
